import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const NEXT = { chapter_1: "chapter_2", chapter_2: "chapter_3" };

export const EndingPanel = ({ chapter, onClose }) => {
  const nav = useNavigate();
  const nextId = NEXT[chapter];
  const [ch, setCh] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!nextId) return; api.get("/chapters").then(({ data }) => setCh(data.find((c) => c.id === nextId))).catch(() => {}); }, [nextId]);
  const buy = async () => {
    setBusy(true);
    try { const { data } = await api.post("/payments/checkout", { chapter_id: nextId, origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  if (!nextId) return (
    <div className="fixed sm:absolute inset-0 z-50 sm:z-30 bg-black/85 flex items-center justify-center p-3 sm:p-4 overflow-y-auto rise" data-testid="ending-panel">
      <div className="pixel-panel relative p-5 sm:p-8 max-w-lg w-full">
        <p className="font-blocky text-[10px] text-[#DC2626] tracking-widest">GODS WE CALL</p>
        <h2 className="font-blocky text-lg sm:text-3xl text-[#F3F4F6] mt-3 leading-relaxed" data-testid="ending-next-title">THE END</h2>
        <p className="pixel-text text-lg sm:text-xl text-[#9CA3AF] mt-3">Thank you for playing. Gods We Call will be made into a feature film, and every chapter you played helps make it happen.</p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <button className="pixel-btn" onClick={() => nav("/")} data-testid="ending-menu-button">Chapters</button>
          <button className="pixel-btn ghost" onClick={onClose} data-testid="ending-close-button">Keep exploring</button>
        </div>
      </div>
    </div>
  );
  return (
    <div className="fixed sm:absolute inset-0 z-50 sm:z-30 bg-black/85 flex items-center justify-center p-3 sm:p-4 overflow-y-auto rise" data-testid="ending-panel">
      <div className="pixel-panel relative p-5 sm:p-8 max-w-lg w-full">
        <p className="font-blocky text-[10px] text-[#DC2626] tracking-widest">END OF CHAPTER {chapter === "chapter_2" ? "TWO" : "ONE"} · TO BE CONTINUED</p>
        <h2 className="font-blocky text-sm sm:text-xl text-[#F3F4F6] mt-3 leading-relaxed" data-testid="ending-next-title">
          {ch ? `CHAPTER ${ch.number}: ${ch.title.toUpperCase()}` : "..."}
        </h2>
        <p className="pixel-text text-lg sm:text-xl text-[#9CA3AF] mt-3">{ch?.blurb}</p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          {ch?.owned && ch.available ? (
            <button className="pixel-btn font-blocky !text-xs" onClick={() => { window.location.href = `/play/${nextId}`; }} data-testid="ending-play-next-button">▶ PLAY CHAPTER {ch.number}</button>
          ) : ch?.owned ? (
            <span className="pixel-text text-xl text-[#F59E0B]" data-testid="ending-preordered">PRE-ORDERED · You'll get it the day it's released</span>
          ) : (
            <button className="pixel-btn font-blocky !text-xs" disabled={busy || !ch} onClick={buy} data-testid="ending-unlock-next-button">
              {busy ? "..." : `▶ ${ch?.available ? "UNLOCK" : "PRE-ORDER"} $${(ch?.price ?? 0.99).toFixed(2)}`}
            </button>
          )}
          <button className="pixel-btn ghost" onClick={() => nav("/")} data-testid="ending-menu-button">Chapters</button>
          <button className="pixel-btn ghost" onClick={onClose} data-testid="ending-close-button">Keep exploring</button>
        </div>
      </div>
    </div>
  );
};
